import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { privateHttp } from "../../../config/axios";
import { API_ENDPOINTS } from "../../../config/endpoints";
import { BusinessAuthUserInfoResponse } from "../../../types/common";

// Query Keys
export const BUSINESS_AUTH_QUERY_KEYS = {
  userInfo: ["business", "auth", "userInfo"],
} as const;

interface ActiveAlarmReadResponse {
  statusCode: number;
  message?: string;
}

// Business Auth User Info API
const getBusinessAuthUserInfo =
  async (): Promise<BusinessAuthUserInfoResponse> => {
    try {
      const { data } = await privateHttp.get(
        API_ENDPOINTS.AUTH_BUSINESS.USER_INFO
      );
      return data.data;
    } catch (error) {
      console.error("Business Auth User Info API 호출 에러:", error);
      throw error;
    }
  };

// Business Auth User Info React Query Hook
export const useBusinessAuthUserInfo = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [...BUSINESS_AUTH_QUERY_KEYS.userInfo],
    queryFn: () => getBusinessAuthUserInfo(),
    select: (data) => data,
    enabled: enabled,
  });
};

const readBusinessActiveAlarm = async (): Promise<ActiveAlarmReadResponse> => {
  try {
    const { data } = await privateHttp.post(
      API_ENDPOINTS.AUTH_BUSINESS.ACTIVE_ALARM_READ
    );
    return data;
  } catch (error) {
    console.error("Business active alarm read API 호출 에러:", error);
    throw error;
  }
};

export const useReadBusinessActiveAlarm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: readBusinessActiveAlarm,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: BUSINESS_AUTH_QUERY_KEYS.userInfo,
      });
    },
  });
};

// Business Auth Has Company API (동일한 파라미터, 동일한 리턴)
const getBusinessAuthHasCompany =
  async (): Promise<BusinessAuthUserInfoResponse> => {
    try {
      const { data } = await privateHttp.get(
        API_ENDPOINTS.AUTH_BUSINESS.HAS_COMPANY
      );
      return data.data;
    } catch (error) {
      console.error("Business Auth Has Company API 호출 에러:", error);
      throw error;
    }
  };

export { getBusinessAuthUserInfo, getBusinessAuthHasCompany };
